module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_15.png?639328540af97909a7284cbe058e47d2";